import { PaymasterFactory } from './PaymasterFactory'

export const paymasterFactory = new PaymasterFactory()
